import type { Logger } from "@expert/logging";
import type { Partner } from "@expert/shared-types";
import ky from "ky";
import { defaultHeaders, defaultTimeoutInMS } from "../types";

interface ActivateDevicePayload {
    partner: Partner;
    callSid: string;
    sessionId: string;
    manualDeviceInfo?: {
        imei: string;
        iccid: string;
    };
}

export const activateDevice = async (
    ssoAccessToken: string,
    payload: ActivateDevicePayload,
    retrieveClaimOrVerifyPasscodeToken: string,
    logger: Logger,
) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/activate`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: { ...payload, token: retrieveClaimOrVerifyPasscodeToken },
            timeout: defaultTimeoutInMS,
        });

        const { result } = await resp.json<{ result: string }>();
        return { wasSuccessful: result === "SUCCESS" };
    } catch (error) {
        logger.error({ error }, `Error: Could not activate device.`);
        return { wasSuccessful: false };
    }
};
